export default __webpack_public_path__ + "static/media/scrollboy_work.f853701a.jpg";